module.exports = __webpack_public_path__ + "static/media/11.final.7db36eba.mp4";